module.exports = __webpack_public_path__ + "static/media/todeal@2x.5fd0b106.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/todeal@2x.png
// module id = 342
// module chunks = 0